import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  return _openBlock(), _createBlock(_component_el_breadcrumb, {
    "separator-icon": $setup.ArrowRight,
    class: "crumb"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paths, i => {
      return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
        key: i.path,
        to: {
          path: i.path
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(i.meta.title), 1)]),
        _: 2
      }, 1032, ["to"]);
    }), 128))]),
    _: 1
  }, 8, ["separator-icon"]);
}